module.exports = __webpack_public_path__ + "static/media/spiekeroog_logo.27179136.jpg";